export const DaysLeft = ({
  value,
  isEnded,
}: {
  value: number;
  isEnded?: boolean;
}) => {
  if (isEnded || value < 0) {
    return <span className="font-600 text-Gray-600 typo-caption1">마감</span>;
  }

  if (value === 0) {
    return <span className="font-600 text-R-500 typo-caption1">오늘 마감</span>;
  }

  if (value < 10) {
    return (
      <span className="font-600 text-R-300 typo-caption1">{value}일 남음</span>
    );
  }

  return (
    <span className="font-600 text-Gray-600 typo-caption1">
      {value}일 남음
    </span>
  );
};
